var k = Object.defineProperty;
var h = (o, t, e) => t in o ? k(o, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : o[t] = e;
var i = (o, t, e) => h(o, typeof t != "symbol" ? t + "" : t, e);
import { RpcProvider as f, Account as A, Contract as u, CallData as l, cairo as m } from "starknet";
function y(o) {
  return new f({
    nodeUrl: o
  });
}
function g(o, t) {
  return new A(y(o), t.address, t.privateKey);
}
const _ = [
  {
    name: "IRegistryImpl",
    type: "impl",
    interface_name: "token_bound_accounts::interfaces::IRegistry::IRegistry"
  },
  {
    name: "core::integer::u256",
    type: "struct",
    members: [
      {
        name: "low",
        type: "core::integer::u128"
      },
      {
        name: "high",
        type: "core::integer::u128"
      }
    ]
  },
  {
    name: "token_bound_accounts::interfaces::IRegistry::IRegistry",
    type: "interface",
    items: [
      {
        name: "create_account",
        type: "function",
        inputs: [
          {
            name: "implementation_hash",
            type: "core::felt252"
          },
          {
            name: "token_contract",
            type: "core::starknet::contract_address::ContractAddress"
          },
          {
            name: "token_id",
            type: "core::integer::u256"
          },
          {
            name: "salt",
            type: "core::felt252"
          }
        ],
        outputs: [
          {
            type: "core::starknet::contract_address::ContractAddress"
          }
        ],
        state_mutability: "external"
      },
      {
        name: "get_account",
        type: "function",
        inputs: [
          {
            name: "implementation_hash",
            type: "core::felt252"
          },
          {
            name: "token_contract",
            type: "core::starknet::contract_address::ContractAddress"
          },
          {
            name: "token_id",
            type: "core::integer::u256"
          },
          {
            name: "salt",
            type: "core::felt252"
          }
        ],
        outputs: [
          {
            type: "core::starknet::contract_address::ContractAddress"
          }
        ],
        state_mutability: "view"
      },
      {
        name: "total_deployed_accounts",
        type: "function",
        inputs: [
          {
            name: "token_contract",
            type: "core::starknet::contract_address::ContractAddress"
          },
          {
            name: "token_id",
            type: "core::integer::u256"
          }
        ],
        outputs: [
          {
            type: "core::integer::u8"
          }
        ],
        state_mutability: "view"
      }
    ]
  },
  {
    kind: "struct",
    name: "token_bound_accounts::registry::registry::Registry::AccountCreated",
    type: "event",
    members: [
      {
        kind: "data",
        name: "account_address",
        type: "core::starknet::contract_address::ContractAddress"
      },
      {
        kind: "data",
        name: "token_contract",
        type: "core::starknet::contract_address::ContractAddress"
      },
      {
        kind: "data",
        name: "token_id",
        type: "core::integer::u256"
      }
    ]
  },
  {
    kind: "enum",
    name: "token_bound_accounts::registry::registry::Registry::Event",
    type: "event",
    variants: [
      {
        kind: "nested",
        name: "AccountCreated",
        type: "token_bound_accounts::registry::registry::Registry::AccountCreated"
      }
    ]
  }
], p = [
  {
    name: "IAccountImpl",
    type: "impl",
    interface_name: "token_bound_accounts::interfaces::IAccount::IAccount"
  },
  {
    name: "core::array::Span::<core::felt252>",
    type: "struct",
    members: [
      {
        name: "snapshot",
        type: "@core::array::Array::<core::felt252>"
      }
    ]
  },
  {
    name: "core::starknet::account::Call",
    type: "struct",
    members: [
      {
        name: "to",
        type: "core::starknet::contract_address::ContractAddress"
      },
      {
        name: "selector",
        type: "core::felt252"
      },
      {
        name: "calldata",
        type: "core::array::Array::<core::felt252>"
      }
    ]
  },
  {
    name: "core::integer::u256",
    type: "struct",
    members: [
      {
        name: "low",
        type: "core::integer::u128"
      },
      {
        name: "high",
        type: "core::integer::u128"
      }
    ]
  },
  {
    name: "core::bool",
    type: "enum",
    variants: [
      {
        name: "False",
        type: "()"
      },
      {
        name: "True",
        type: "()"
      }
    ]
  },
  {
    name: "token_bound_accounts::interfaces::IAccount::IAccount",
    type: "interface",
    items: [
      {
        name: "is_valid_signature",
        type: "function",
        inputs: [
          {
            name: "hash",
            type: "core::felt252"
          },
          {
            name: "signature",
            type: "core::array::Span::<core::felt252>"
          }
        ],
        outputs: [
          {
            type: "core::felt252"
          }
        ],
        state_mutability: "view"
      },
      {
        name: "__validate__",
        type: "function",
        inputs: [
          {
            name: "calls",
            type: "core::array::Array::<core::starknet::account::Call>"
          }
        ],
        outputs: [
          {
            type: "core::felt252"
          }
        ],
        state_mutability: "external"
      },
      {
        name: "__validate_declare__",
        type: "function",
        inputs: [
          {
            name: "class_hash",
            type: "core::felt252"
          }
        ],
        outputs: [
          {
            type: "core::felt252"
          }
        ],
        state_mutability: "view"
      },
      {
        name: "__validate_deploy__",
        type: "function",
        inputs: [
          {
            name: "class_hash",
            type: "core::felt252"
          },
          {
            name: "contract_address_salt",
            type: "core::felt252"
          }
        ],
        outputs: [
          {
            type: "core::felt252"
          }
        ],
        state_mutability: "view"
      },
      {
        name: "__execute__",
        type: "function",
        inputs: [
          {
            name: "calls",
            type: "core::array::Array::<core::starknet::account::Call>"
          }
        ],
        outputs: [
          {
            type: "core::array::Array::<core::array::Span::<core::felt252>>"
          }
        ],
        state_mutability: "external"
      },
      {
        name: "token",
        type: "function",
        inputs: [],
        outputs: [
          {
            type: "(core::starknet::contract_address::ContractAddress, core::integer::u256)"
          }
        ],
        state_mutability: "view"
      },
      {
        name: "owner",
        type: "function",
        inputs: [
          {
            name: "token_contract",
            type: "core::starknet::contract_address::ContractAddress"
          },
          {
            name: "token_id",
            type: "core::integer::u256"
          }
        ],
        outputs: [
          {
            type: "core::starknet::contract_address::ContractAddress"
          }
        ],
        state_mutability: "view"
      },
      {
        name: "upgrade",
        type: "function",
        inputs: [
          {
            name: "implementation",
            type: "core::starknet::class_hash::ClassHash"
          }
        ],
        outputs: [],
        state_mutability: "external"
      },
      {
        name: "lock",
        type: "function",
        inputs: [
          {
            name: "duration",
            type: "core::integer::u64"
          }
        ],
        outputs: [],
        state_mutability: "external"
      },
      {
        name: "is_locked",
        type: "function",
        inputs: [],
        outputs: [
          {
            type: "(core::bool, core::integer::u64)"
          }
        ],
        state_mutability: "view"
      },
      {
        name: "supports_interface",
        type: "function",
        inputs: [
          {
            name: "interface_id",
            type: "core::felt252"
          }
        ],
        outputs: [
          {
            type: "core::bool"
          }
        ],
        state_mutability: "view"
      }
    ]
  },
  {
    name: "constructor",
    type: "constructor",
    inputs: [
      {
        name: "token_contract",
        type: "core::starknet::contract_address::ContractAddress"
      },
      {
        name: "token_id",
        type: "core::integer::u256"
      }
    ]
  },
  {
    kind: "struct",
    name: "token_bound_accounts::account::account::Account::AccountCreated",
    type: "event",
    members: [
      {
        kind: "key",
        name: "owner",
        type: "core::starknet::contract_address::ContractAddress"
      }
    ]
  },
  {
    name: "core::array::Span::<core::array::Span::<core::felt252>>",
    type: "struct",
    members: [
      {
        name: "snapshot",
        type: "@core::array::Array::<core::array::Span::<core::felt252>>"
      }
    ]
  },
  {
    kind: "struct",
    name: "token_bound_accounts::account::account::Account::TransactionExecuted",
    type: "event",
    members: [
      {
        kind: "key",
        name: "hash",
        type: "core::felt252"
      },
      {
        kind: "data",
        name: "response",
        type: "core::array::Span::<core::array::Span::<core::felt252>>"
      }
    ]
  },
  {
    kind: "struct",
    name: "token_bound_accounts::account::account::Account::Upgraded",
    type: "event",
    members: [
      {
        kind: "data",
        name: "tokenContract",
        type: "core::starknet::contract_address::ContractAddress"
      },
      {
        kind: "data",
        name: "tokenId",
        type: "core::integer::u256"
      },
      {
        kind: "data",
        name: "implementation",
        type: "core::starknet::class_hash::ClassHash"
      }
    ]
  },
  {
    kind: "enum",
    name: "token_bound_accounts::account::account::Account::Event",
    type: "event",
    variants: [
      {
        kind: "nested",
        name: "AccountCreated",
        type: "token_bound_accounts::account::account::Account::AccountCreated"
      },
      {
        kind: "nested",
        name: "TransactionExecuted",
        type: "token_bound_accounts::account::account::Account::TransactionExecuted"
      },
      {
        kind: "nested",
        name: "Upgraded",
        type: "token_bound_accounts::account::account::Account::Upgraded"
      }
    ]
  }
];
class C {
  constructor(t) {
    i(this, "account");
    i(this, "jsonRPC");
    i(this, "registryAddress");
    i(this, "implementationAddress");
    i(this, "isInitialized", !1);
    const { walletClient: e, account: n, jsonRPC: a, registryAddress: r, implementationAddress: c } = t;
    if (n && e)
      throw new Error("only one of `account` or `walletClient` is required!");
    n ? this.account = n : this.account = g(a, e), this.jsonRPC = a, this.registryAddress = r, this.implementationAddress = c;
  }
  async getAccount(t) {
    const { tokenContract: e, tokenId: n, salt: a } = t, r = y(this.jsonRPC), c = new u(_, this.registryAddress, r);
    try {
      return await c.get_account(
        this.implementationAddress,
        e,
        n,
        a || n
      );
    } catch (s) {
      throw s;
    }
  }
  async createAccount(t) {
    const { tokenContract: e, tokenId: n, salt: a } = t, r = new u(_, this.registryAddress, this.account);
    let c = a || n;
    try {
      return await r.create_account(
        this.implementationAddress,
        e,
        n,
        c
      ), await this.getAccount({
        tokenContract: e,
        tokenId: n,
        salt: c
      });
    } catch (s) {
      throw s;
    }
  }
  async checkAccountDeployment(t) {
    const { tokenContract: e, tokenId: n, salt: a } = t, r = y(this.jsonRPC);
    let c = a || n, s = await this.getAccount({
      tokenContract: e,
      tokenId: n,
      salt: c
    });
    try {
      const d = await r.getClassHashAt(s);
      if (d)
        return { deployed: !0, classHash: d };
    } catch {
      return { deployed: !1, classHash: "" };
    }
  }
  async execute(t, e) {
    const n = y(this.jsonRPC);
    let a = {
      contractAddress: t,
      entrypoint: "__execute__",
      calldata: l.compile({
        calls: e
      })
    };
    try {
      const r = await this.account.execute(a);
      return await n.waitForTransaction(r.transaction_hash), !0;
    } catch (r) {
      throw r;
    }
  }
  async lock(t) {
    const { tbaAddress: e, duration_in_sec: n } = t, a = new u(p, e, this.account);
    try {
      await a.lock(n);
    } catch (r) {
      throw r;
    }
  }
  async is_locked(t) {
    const e = y(this.jsonRPC), n = new u(p, t, e);
    try {
      return await n.is_locked();
    } catch (a) {
      throw a;
    }
  }
  async getOwner(t) {
    let { tbaAddress: e, tokenContract: n, tokenId: a } = t;
    const r = new u(p, e, this.account);
    try {
      return await r.owner(n, a);
    } catch (c) {
      throw c;
    }
  }
  async getOwnerNFT(t) {
    const e = new u(p, t, this.account);
    try {
      return await e.token();
    } catch (n) {
      throw n;
    }
  }
  async transferERC20(t) {
    const { tbaAddress: e, contractAddress: n, recipient: a, amount: r } = t;
    let c = {
      to: n,
      selector: "0x83afd3f4caedc6eebf44246fe54e38c95e3179a5ec9ea81740eca5b482d12e",
      calldata: l.compile({
        recipient: a,
        amount: m.uint256(r)
      })
    };
    try {
      return await this.execute(e, [c]);
    } catch (s) {
      throw s;
    }
  }
  async transferNFT(t) {
    const { tbaAddress: e, contractAddress: n, tokenId: a, sender: r, recipient: c } = t;
    let s = {
      to: n,
      selector: "0x41b033f4a31df8067c24d1e9b550a2ce75fd4a29e1147af9752174f0e6cb20",
      calldata: l.compile({
        from_: r,
        to: c,
        amount: m.uint256(a)
      })
    };
    try {
      return await this.execute(e, [s]);
    } catch (d) {
      throw d;
    }
  }
  async signMessage(t) {
    try {
      return await this.account.signMessage(t);
    } catch (e) {
      throw e;
    }
  }
}
export {
  C as TokenboundClient
};
